import { AddressDto, AddressDtoSchema } from "@modules/address/addressDto"
import { BoxSubscriptionStatus } from "@modules/boxSubscription/gateway/boxSubscriptionApiDto"
import { HUImageDtoSchema } from "@modules/dtos/imageDto"
import { PublicProfileDto } from "@modules/profile/publicProfile/publicProfileDto"
import { z } from "zod"

export const allMemberFilters = ["all", "prospect", "active", "terminated", "staff", "drop_in"] as const
export type MemberFilter = (typeof allMemberFilters)[number]

export enum MemberStatus {
  ACTIVE = "ACTIVE",
  PROSPECT = "PROSPECT",
  TERMINATED = "TERMINATED",
  DROP_IN = "DROP_IN",
}

export const MemberActiveOfferDtoSchema = z.object({
  offerName: z.string(),
  endValidity: z.string().nullish(),
  endSubscription: z.string().nullish(),
  subscriptionStatus: z.nativeEnum(BoxSubscriptionStatus).nullish(),
})

export const MemberItemDtoSchema = z.object({
  id: z.string(),
  avatar: HUImageDtoSchema.nullish(),
  firstname: z.string(),
  lastname: z.string(),
  username: z.string(),
  status: z.nativeEnum(MemberStatus),
  note: z.string().nullish(),
  lastVisited: z.string().datetime().nullish(),
  noShowPastMonth: z.number().nullish(),
  activeOffers: z.array(MemberActiveOfferDtoSchema),
})

export const BoxMemberNextBookingDtoSchema = z.object({
  slotId: z.string(),
  name: z.string(),
  date: z.string().datetime(),
  color: z.string(),
})

export const MemberDetailedDraftDtoSchema = z.object({
  firstname: z.string(),
  lastname: z.string(),
  username: z.string().nullish(),
  birthDate: z.string().nullish(),
  phone: z.string(),
  email: z.string(),
  address: AddressDtoSchema.nullable(),
  emergencyInformation: z.string(),
  note: z.string(),
  activeOffersTitles: z.array(z.string()).nullish(),
})

export const MemberDetailedUpadteInputSchema = z.object({
  firstname: z.string().nullish(),
  lastname: z.string().nullish(),
  birthDate: z.string().nullish(),
  phone: z.string().nullish(),
  address: AddressDtoSchema.nullable().nullish(),
  emergencyInformation: z.string(),
  note: z.string(),
})

export type MemberDetailedDto = {
  id: string
  userId: string
  firstname: string
  lastname: string
  inscriptionDate: string
  status: string
  username: string
  birthDate?: string
  phone: string
  email: string
  address: AddressDto
  emergencyInformation: string
  note?: string
  lastVisited?: string
  noShowPastMonth?: number
  activeOffersTitles?: string[]
  nextBookings: BoxMemberNextBookingDto[]
  publicProfile?: PublicProfileDto
}

export type MemberDetailedUpadteInput = z.infer<typeof MemberDetailedUpadteInputSchema>
export type MemberDetailedDraftDto = z.infer<typeof MemberDetailedDraftDtoSchema>
export type MemberItemDto = z.infer<typeof MemberItemDtoSchema>
export type BoxMemberNextBookingDto = z.infer<typeof BoxMemberNextBookingDtoSchema>
export type MemberActiveOfferDto = z.infer<typeof MemberActiveOfferDtoSchema>
